

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getUnreadEventNotifications
// GETUNREADEVENTNOTIFICATIONS   

const GETUNREADEVENTNOTIFICATIONS= createAsyncThunk(
  "getUnreadEventNotifications/getUnreadEventNotifications",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUnreadEventNotificationsSlice = createSlice({
  name: "getUnreadEventNotificationsSlice",
  initialState: {
    getUnreadEventNotifications: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUnreadEventNotifications: (state) => {
        state.getUnreadEventNotifications.loading = false
        state.getUnreadEventNotifications.error = false
        state.getUnreadEventNotifications.data = []
        state.getUnreadEventNotifications.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUNREADEVENTNOTIFICATIONS.fulfilled, (state, action) => {
      state.getUnreadEventNotifications = {
        ...state.getUnreadEventNotifications,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADEVENTNOTIFICATIONS.pending, (state, action) => {
      state.getUnreadEventNotifications = {
        ...state.getUnreadEventNotifications,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADEVENTNOTIFICATIONS.rejected, (state, action) => {
      state.getUnreadEventNotifications = {
        ...state.getUnreadEventNotifications,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUnreadEventNotificationsAction = {
    GETUNREADEVENTNOTIFICATIONS,
};

export { getUnreadEventNotificationsAction };
export default getUnreadEventNotificationsSlice.reducer;
export const {setInitialStateOfgetUnreadEventNotifications} = getUnreadEventNotificationsSlice.actions